const ITEMS = [
  {
    letter: "R",
    title: "Registration Pathway",
    body: "Confirm the registration class and scope that actually applies to the services delivered today, including any 0115 / 0138 overlap."
  },
  {
    letter: "E",
    title: "Evidence Mapping",
    body: "Identify which governing documents exist, which are current, and which are followed in practice across safeguarding, incidents, medication and screening."
  },
  {
    letter: "A",
    title: "Assessment of Operational Risk",
    body: "Measure the gap between what the documents say and what day-to-day delivery looks like — staffing, supervision, continuity, practice variation."
  },
  {
    letter: "D",
    title: "Danger · Safeguarding Escalation",
    body: "Detect concerns that place automated scoring on hold and require manual review — abuse, neglect, medication safety, restrictive practice, serious incidents."
  },
  {
    letter: "Y",
    title: "Your 30 / 60 / 90 Day Plan",
    body: "Translate the snapshot into a sequenced action plan with a clear next 30 days, the consolidation window, and the readiness checkpoint."
  }
];

export function FrameworkSection() {
  return (
    <section id="framework" className="border-y border-border bg-card/50">
      <div className="container py-16 lg:py-20">
        <div className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="eyebrow">§ 01 · Framework</p>
            <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-foreground sm:text-4xl">
              The R.E.A.D.Y. framework, five readings.
            </h2>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-muted-foreground">
              Each letter is a separate reading of your readiness. They run in sequence inside
              the intake and roll up into a single preliminary snapshot at the end.
            </p>
          </div>
          <div className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
            Nine sections · consultant-guided
          </div>
        </div>

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-border bg-border md:grid-cols-2 lg:grid-cols-5">
          {ITEMS.map((item, i) => (
            <article
              key={item.letter}
              className="flex flex-col gap-4 bg-card p-6 transition-colors hover:bg-card/80"
            >
              <div className="flex items-center justify-between">
                <span className="letter-mark h-10 w-10 text-lg">{item.letter}</span>
                <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-display text-lg font-medium leading-tight text-foreground">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
